import { Injectable } from '@angular/core';
import {PosActivity, PosActivityList} from './pos_activity';
import {BaseService} from '../base/base.service';
import {PosActivitySerializer} from 'src/app/pos_activities/pos_activity.serializer';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PosActivityService extends BaseService<PosActivity, PosActivityList> {

  constructor(http: HttpClient) {
    super(http);
    this.endpoint = 'pos_activities' ;
    this.serializer = new PosActivitySerializer();
  }
}
